<template>
  <div class="flex-row jcsb header">
    <div class="flex-row">
      <!-- logo -->
      <div class="logo">
        <div class="systemTitle">
          <router-link to="/" class="link">
            <img src="@/assets/img/logo.png" alt="" />
          </router-link>
        </div>
      </div>
      <!-- 面包屑 -->
      <div class="crumbsWrap">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item v-for="(item, index) in breadList" :key="index">
            <router-link v-if="item.name && index < breadList.length - 1" :to="{ name: item.name, query: getFilterQuery(item.queryKeys) }">
              {{ getBreadcrumbTitle(item) }}
            </router-link>
            <span class="black" v-else>{{ getBreadcrumbTitle(item) }}</span>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <div class="fs16" v-if="envLabel">{{ envLabel }}</div>

    <div class="flex-row header-right">
      <!-- 语言切换 -->
      <div class="czjz language">
        <el-dropdown trigger="click" @command="languageSelect">
          <span class="crp el-dropdown-link">
            <i class="tagIcon">{{ getLanguage == "zh" ? "CN" : "EN" }}</i>
            {{ $t("common.language") }}
            <i class="vam el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <!-- {{ $t('common.chinese') }} -->
            <el-dropdown-item command="zh" :class="getLanguage == 'zh' ? 'activeLg' : ''">中文</el-dropdown-item>
            <!-- {{ $t('common.english') }} -->
            <el-dropdown-item command="en" :class="getLanguage == 'en' ? 'activeLg' : ''">English</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <!-- 设置 -->
      <div class="ml30 czjz header-user-con">
        <el-dropdown trigger="click" @command="handleCommand">
          <span class="crp el-dropdown-link">
            <i class="vam fs20 black45 el-icon-setting"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="home">{{ $t("home.home") }}</el-dropdown-item>
            <el-dropdown-item command="account">{{ $t("account.account.account") }}</el-dropdown-item>
            <el-dropdown-item command="loginout">{{ $t("common.logOut") }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters("language", ["getLanguage"]),
    ...mapState("applyment", ["applymentDetail"]),
    // 当前申请单国家（接口返回前为空，面包屑回退到默认 title）
    country() {
      return this.applymentDetail?.country || "";
    },
    breadList() {
      return this.$route.meta.breadcrumb || [];
    },
    envLabel() {
      return process.env.VUE_APP_ENV_LABEL || "";
    },
  },
  methods: {
    ...mapActions("user", ["logout"]),
    ...mapActions("language", ["switchLanguage"]),
    // 根据当前申请单国家解析面包屑标题
    // 优先取 titleByCountry[country]，未配置则回退到默认 title
    getBreadcrumbTitle(item) {
      const key = (item.titleByCountry && item.titleByCountry[this.country]) || item.title;
      return this.$t(key);
    },
    // 从当前全量 query 中只挑出需要的 key
    getFilterQuery(keys) {
      // 如果没定义或为空，返回空对象
      if (!keys || keys.length === 0) return {};
      const filtered = {};
      keys.forEach(key => {
        if (this.$route.query[key] !== undefined) {
          filtered[key] = this.$route.query[key];
        }
      });
      return filtered;
    },
    // 设置语言
    languageSelect(command) {
      // 避免重复切换语言
      if (command != this.getLanguage) {
        this.$confirm(this.$t("common.hint.switch"), this.$t("common.hint.title"), {
          type: "warning",
        })
          .then(() => {
            this.switchLanguage(command);
          })
          .catch(() => {});
      }
    },
    // 设置icon
    handleCommand(command) {
      if (command == "loginout") {
        this.$confirm(this.$t("common.hint.quit"), this.$t("common.hint.title"), {
          type: "warning",
        })
          .then(() => {
            // 退出登录
            this.logout();
            this.$router.replace("/login");
          })
          .catch(err => {});
      } else if (command == "account") {
        this.$router.push("/account");
      } else if (command == "home") {
        this.$router.push("/");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  /* height: 50px; */
  font-size: 22px;
  color: #2c3e50;
  /* padding-left: 180px; */
  transition: padding-left 0.3s ease-in-out;
  z-index: 100;
  padding: 18px 30px;

  ::v-deep {
    .link {
      display: inline-block;
      height: 50px;
      color: #011a45;
      font-weight: bold;
    }
  }
}

.header-shrink {
  padding-left: 64px;
}

.collapse-btn {
  padding: 0 19px;
  cursor: pointer;
  line-height: 50px;
}

.header-user-con {
  display: flex;
  height: 50px;
  align-items: center;
}

.btn-bell-badge {
  position: absolute;
  right: 0;
  top: -2px;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: #f56c6c;
  color: #fff;
}

.btn-bell .el-icon-bell {
  color: #2c3e50;
}

.user-avator {
  margin-left: 16px;
  width: 70px;
  text-align: center;
  height: 28px;
  line-height: 26px;
  border: 1px solid #b2b2b2;
  border-radius: 16px;
  cursor: pointer;

  p {
    font-size: 12px;
    color: #606266;
  }
}

.el-dropdown-link {
  display: inline-block;
  width: 100%;
  height: 50px;
  line-height: 50px;
  color: #011a45;
  cursor: pointer;
}

.el-icon-arrow-down {
  font-weight: 800;
  color: #7a89a1;
  opacity: 0.5;
  margin-left: 0px;
}

.el-dropdown-link:focus {
  border: none;
  outline: none;
}

.el-dropdown-menu__item {
  text-align: center;
  color: #011a45;
}

.el-dropdown-menu__item--divided:before {
  height: 0;
}

.el-dropdown-menu__item--divided {
  margin-top: 0;
  border-top: none;
}

.el-dropdown-menu {
  padding: 0;
  /* padding: 5px 0; */
}

.el-dropdown-menu__item {
  line-height: 40px !important;
  padding: 0 28px !important;
}

.crumbsWrap {
  height: 100%;
  padding-left: 20px;

  ::v-deep {
    .el-breadcrumb {
      line-height: 50px;
    }
  }
}

.language {
  line-height: 50px;
}

.activeLg {
  color: #0060ff;
}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  color: #0060ff;
}

.logo {
  height: 50px;
  transition: width 0.3s ease-in-out;
  z-index: 300;
}

.systemTitle {
  height: 50px;

  img {
    height: 100%;
  }
}

.tagIcon {
  display: inline-block;
  width: 22px;
  text-align: center;
  height: 20px;
  line-height: 20px;
  background: #011a45;
  opacity: 0.5;
  border-radius: 4px;
  color: #fff;
  font-size: 10px;
  font-weight: bold;
  margin-right: 8px;
}
</style>
